const validInspectionImageTypes = ["image/jpeg", "image/png"];

export default validInspectionImageTypes;
